<div class="PropertyImage">
  <div class="PropertyImage__Wrapper">
    <smartflip-photo-carousel
      class="PropertyImage__Carousel"
      [initialSlideIndex]="initialSlideIndex"
      [photos]="propertyPhotos"
    ></smartflip-photo-carousel>
    <!-- <div
    class="PropertyImage__Image"
    [ngClass]="imgClass"
    [ngStyle]="{ 'background-image': 'url(' + imgUrl + ')' }"
  ></div> -->
  </div>
  <!-- Zoom button -->
  @if (!disableFullscreen) {
    <ion-button
      class="PropertyImage__Button"
      color="primary"
      (click)="fullScreen()"
      [disabled]="usingDefaultImage()"
    >
      Full Screen
    </ion-button>
  }

  <!-- Upload button -->
  @if (useUpload) {
    @if (editable) {
      <ion-button
        class="PropertyImage__Button"
        color="primary"
        (click)="uploadImage()"
      >
        Upload New Photo
      </ion-button>
    } @else {
      <p class="PropertyImage__UploadWarning">
        Please log into
        <a href="https://app.thesmartflip.com" target="_blank"
          >https://app.thesmartflip.com</a
        >
        to upload a new photo
      </p>
    }
  }
</div>
